import {
  FILL_VALUE,
  getLangFromLocale,
  interpolate,
  type LangLocale,
  type TranslateOptions,
} from '@myre/common-i18n';
import { type Scope } from '@myre/domain-i18n-core';

import { importI18n } from './i18n.import';

export async function loadI18n(
  staticEnv: 'development' | 'production',
  scope: Scope,
  langLocale: LangLocale,
  options: {
    variant?: string;
    withFrontendLibs?: boolean;
  },
): Promise<any> {
  const { variant } = options;

  return importI18n(
    scope,
    langLocale,
    ({ wording, registerCallback }) => {
      const lang = getLangFromLocale(langLocale);

      registerCallback((str: string, translateOptions: TranslateOptions) =>
        interpolate(
          staticEnv === 'production' && str === FILL_VALUE ? '' : str,
          {
            ...translateOptions,
            i18n: {
              lang,
              langLocale,
              langLocaleWithVariant: variant
                ? `${langLocale}-${variant}`
                : langLocale,
            },
          },
          wording,
        ),
      );

      return wording;
    },
    options,
  );
}
